import script from "./Autorefresh.vue?vue&type=script&setup=true&lang=ts"
export * from "./Autorefresh.vue?vue&type=script&setup=true&lang=ts"

import "./Autorefresh.vue?vue&type=style&index=0&id=67618a78&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67618a78"]])

export default __exports__